import React from "react";
import { Route } from "react-router";
import LessonTablePage from "../Pages/LessonTablePage/LessonTablePage";
import EventsPage from "../Pages/EventsPage/EventsPage";
import NotificationPage from "../Pages/NotificationPage/NotificationPage";

const TeacherPanelRoute = () => {
  return (
    <>
      <Route path="/teacher-panel/" element={<LessonTablePage />} />
      {/* <Route path="/event/" element={<EventsPage />} /> */}
      <Route path="/notifications" element={<NotificationPage />} />
    </>
  );
};

export default TeacherPanelRoute;
